import React from 'react';
import {useTranslation} from 'react-i18next';
import ClientInfoUnit from './ClientInfoUnit';
import styles from './ClientInfoColumn.module.css';
import {ClientCardType} from '../../../../../types/TypesUser';

interface ClientInfoColumnProps {
	data: ClientCardType;
	onParentClick: (parentId: number) => void;
}

const ClientInfoColumn: React.FC<ClientInfoColumnProps> = ({
	data,
	onParentClick,
}) => {
	const {t} = useTranslation();
	return (
		<div className={styles.clientInfoColumn}>
			<ClientInfoUnit label="НОМЕР ID" value={data.user_id} />
			<ClientInfoUnit 
				label={t('Номер контракту')} 
				value={data.contract} 
			/>
			<ClientInfoUnit label={t('Дата народження')} value={data.birth_date || ''} />
			<ClientInfoUnit label={t('МІСТО')} value={data.address} />
			<ClientInfoUnit label={t('КОНТАКТ')} value={data.contact} isPhone={true} />
			<ClientInfoUnit
				label={t('Спонсор')}
				value={data.parent_name || ''}
				isClickable={true}
				onClick={() => onParentClick(data.parent_id)}
			/>
			<ClientInfoUnit label={t('Особистий ТО')} value={data.active_points} />
			<ClientInfoUnit label={t('Командний ТО')} value={data.active_points_tree} />
		</div>
	);
};

export default ClientInfoColumn;
